import { ModuleFE_ContextRule } from '@app/hcs-frontend';
export const getSelectedContextRulesIds = (organizationContextRulesIds) => ModuleFE_ContextRule.cache.filter(({ _id }) => !!organizationContextRulesIds?.includes(_id));
//# sourceMappingURL=utils.js.map